import {
  Button,
  CircularProgress
} from '@material-ui/core';
import { Create } from '@material-ui/icons';
import React, { useState } from "react";
import { useSelector } from 'react-redux';
import { i18n } from "../../config";
import BateriaVirtualDialog from './BateriaVirtualDialog';


const BateriaVirtualDialogOpenButton = ({bateria_virtual}) => {
  const sending = useSelector((state) => state.bateriaVirtual.waitingChangeRequest);
  const [ dialogOpen, setDialogOpen ] = useState(false);

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };
    
  return (
    <div>
      <span>
        <Button variant={'contained'} color={'primary'} onClick={handleDialogOpen}>
          {(sending) ? <CircularProgress color='secondary' style={{ marginRight: 10 }} size={25} /> : <Create style={{marginRight: 10}}/>}
          { i18n.t('common:text.virtual_battery_modify_percentage') } 
        </Button>
      </span>
        <BateriaVirtualDialog 
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          bateria_virtual={bateria_virtual} 
          />
    </div>
  );

}


export default BateriaVirtualDialogOpenButton;
